'use client';

import React, { useMemo } from 'react';
import { useTranslationDetector } from '@/hooks/useTranslationDetector';
import NearbyPlacesSection from './NearbyPlacesSection'
import MapViewModal from '@/components/featured/common/cards/MapViewModal'

const STATIC_LATITUDE = "41.0082";
const STATIC_LONGITUDE = "28.9784";
const STATIC_HOTEL_NAME = "Liberty Hotels Lara - Her Şey Dahil";

export default function HotelInfoSection({ hotelData, onMapViewOpen }) {
  const t = useTranslationDetector('hotel');
  const surveyScore = hotelData?.SurveyScore || 0;
  const reviewCount = hotelData?.ReviewCount || 0;
  const nearestPois = hotelData?.NearestPois || [];

  // Score'a göre rating text'i belirle
  const getRatingText = (score) => {
    if (score >= 9) return t('Excellent');
    if (score >= 8) return t('Great');
    if (score >= 7) return t('VeryGood');
    if (score >= 6) return t('ratingAverage');
    return t('ratingInsufficient');
  };

  // NearestPois'i formatla
  const formattedPlaces = nearestPois.map((poi) => ({
    id: poi.Name,
    name: poi.Name,
    distance: `${poi.Distance.toFixed(1)} ${poi.Unit}`,
  }));

  // API'den gelen koordinatları kullan, yoksa default değerleri kullan
  const latitude = hotelData?.Latitude || STATIC_LATITUDE;
  const longitude = hotelData?.Longitude || STATIC_LONGITUDE;
  const hotelName = hotelData?.HotelName || STATIC_HOTEL_NAME;

  // Türkçe formatındaki koordinatları (virgülle ayrılmış) nokta ile değiştir
  const normalizedLat = latitude.toString().replace(',', '.');
  const normalizedLng = longitude.toString().replace(',', '.');

  // MapSrc oluştur
  const mapSrc = useMemo(() => {
    return `https://maps.google.com/?q=${normalizedLat},${normalizedLng}&output=embed`;
  }, [normalizedLat, normalizedLng]);

  return (
    <div className='md:flex md:flex-col md:gap-6 w-full min-w-0 max-w-full overflow-hidden'>
      {(surveyScore > 0 || reviewCount > 0) && (
        <div className='hidden md:block'>
          <div className='border border-primary-weak bg-background-global rounded-md flex items-center justify-between h-[55px] py-3 px-4'>
            {surveyScore > 0 && (
              <div className='flex items-center gap-[6px]'>
                <span className='text-white text-sm font-medium bg-foreground rounded-md px-[6px] py-1'>
                  {surveyScore.toFixed(1)}
                </span>
                <span className='text-foreground text-sm font-medium'>
                  {getRatingText(surveyScore)}
                </span>
              </div>
            )}
            {reviewCount > 0 && (
              <div className='text-primary font-medium text-sm'>
                {t('reviewCount', { count: reviewCount })}
              </div>
            )}
          </div>
        </div>
      )}
      <div className='flex flex-col md:gap-4 gap-5 w-full min-w-0 max-w-full overflow-hidden'>
        <MapViewModal
          containerClassName='sm:hidden h-[122px]! shadow-none!'
          buttonClassName='h-[40px]! text-sm! leading-16! font-medium! max-w-[140px]!'
          mapSrc={mapSrc}
          mapTitle={hotelName}
          modalMapFullHeight={true}
          onMapViewOpen={onMapViewOpen}
        />
        <NearbyPlacesSection places={formattedPlaces} />
      </div>

    </div>
  )
}
